/* Publish the header height as a CSS variable, like Dawn's header does,
   so sticky offsets elsewhere in the theme keep working. */
(function () {
  function update() {
    var nav = document.querySelector('.oh-nav');
    if (!nav) return;
    document.documentElement.style.setProperty('--header-height', nav.offsetHeight + 'px');
  }
  update();
  window.addEventListener('resize', update);
  document.addEventListener('shopify:section:load', update);
})();
